module.exports = __webpack_public_path__ + "static/media/react-icon.4af927e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/react-icon.png
// module id = 39
// module chunks = 0